var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAhrFilledIconEight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2919 2.27284C19.7589 1.73984 18.8359 2.10384 18.8359 2.84484V7.38184C18.8359 9.27985 20.4479 10.8528 22.4109 10.8528C23.6459 10.8658 25.3619 10.8658 26.8309 10.8658C27.5719 10.8658 27.9619 9.99485 27.4419 9.47485C25.5699 7.58985 22.2159 4.19684 20.2919 2.27284Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 12.647H22.643C19.562 12.647 17.053 10.138 17.053 7.057V3.3C17.053 2.585 16.468 2 15.753 2H10.241C6.237 2 3 4.6 3 9.241V20.759C3 25.4 6.237 28 10.241 28H20.459C24.463 28 27.7 25.4 27.7 20.759V13.947C27.7 13.232 27.115 12.647 26.4 12.647ZM14.7 22.475H9.5C8.967 22.475 8.525 22.033 8.525 21.5C8.525 20.967 8.967 20.525 9.5 20.525H14.7C15.233 20.525 15.675 20.967 15.675 21.5C15.675 22.033 15.233 22.475 14.7 22.475ZM17.3 17.275H9.5C8.967 17.275 8.525 16.833 8.525 16.3C8.525 15.767 8.967 15.325 9.5 15.325H17.3C17.833 15.325 18.275 15.767 18.275 16.3C18.275 16.833 17.833 17.275 17.3 17.275Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhrFilledIconEight);
export default __webpack_public_path__ + "static/media/ahr-filled-icon-eight.52be90274fc1a0c277822fc2cc92cb8b.svg";
export { ForwardRef as ReactComponent };